import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const EnergySavingsLeafSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default EnergySavingsLeafSVG;
